import { useFormik } from "formik";

import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import RoundedButton from "src/shadcn/components/custom/RoundedButton";

import { RESET_PASSWORD_FORM_FIELDS, resetpassword_initialValues, ResetPasswordFormValidationSchema } from "./modules";
import { catchAsync, successTheme } from "src/helpers";
import { AxiosResponse } from "axios";
import { toast } from "sonner";
import { getTempDataRootState, resetMobileNoForValidatOtp, resetSession } from "src/redux/reducers/tempDataSlice";
import RenderFormComponents from "src/shadcn/components/custom/RenderFormComponents";
import { changePasswordRequestApi } from "src/services/requests/Auth";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";

type Props = {};

const ResetPassword = (props: Props) => {
  const [isLoading, setisLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { mobile_no_for_validate_otp, session } = useSelector((state: RootState) => getTempDataRootState(state));

  const formik = useFormik({
    initialValues: resetpassword_initialValues,
    validationSchema: ResetPasswordFormValidationSchema,
    onSubmit: () => {
      // Handle form submission here
      handleResetPasswordForm();
    },
  });

  const handleResetPasswordForm = catchAsync(
    async () => {
      setisLoading(true);
      return await changePasswordRequestApi({
        ...formik.values,
        mobileNumber: mobile_no_for_validate_otp,
      });
    },
    (result: AxiosResponse) => {
      if (result.status === 200) {
        // dispatch(resetEmailForValidatOtp())
        dispatch(resetMobileNoForValidatOtp());
        dispatch(resetSession());
        formik.resetForm();
        toast.success("Password reset successful, You can login now.", { style: successTheme });
        navigate("/");
      }
      setisLoading(false);
    },
    () => {
      setisLoading(false);
    }
  );

  return (
    <div>
      <div className="space-y-4">
        <div className=" font-bold uppercase text-primary">RESET PASSWORD</div>
        <div className="text-xs">Set new password for log in</div>
        <form className="space-y-2" onSubmit={formik.handleSubmit}>
          <div className="space-y-2">
            {RESET_PASSWORD_FORM_FIELDS.map((field: any) => {
              return (
                <RenderFormComponents
                  key={`reset-password-form-${field.dataKey}`}
                  formik={formik}
                  value={formik.values[field.dataKey as keyof object]}
                  {...field}
                  onChange={(e: any) => formik.setFieldValue(field.dataKey, e)}
                />
              );
            })}
          </div>
          <div>
            <RoundedButton isLoading={isLoading} type="submit" className="w-full">
              Submit
            </RoundedButton>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
